import { render, staticRenderFns } from "./SettingsNumber.vue?vue&type=template&id=c83098e4&scoped=true"
import script from "./SettingsNumber.vue?vue&type=script&lang=js"
export * from "./SettingsNumber.vue?vue&type=script&lang=js"
import style0 from "./SettingsNumber.vue?vue&type=style&index=0&id=c83098e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83098e4",
  null
  
)

export default component.exports